export const PrimaryTextColor = '#b1b1b1';
export const PrimaryButtonTextColor = '#cecece';
